<script setup lang="ts" name="AdminScheduleIndex">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

const route = useRoute();
const routeKey = computed(
  () => `${String(route.name)}-${Object.values(route.params).join('-')}`,
);
</script>

<template>
  <RouterView :key="routeKey" />
</template>
